import axios from "axios";
import _ from 'lodash';
import constants from "./constants";


export default axios.create({
  baseURL: constants.baseURL,
  headers: {
    "Content-Type": "application/json",
    "Authorization": "Bearer " + _.get(JSON.parse(localStorage.getItem('user')), ['Token'])
  }
});